import enableScroll from "./enable-scroll";

export default () => {
	const products = document.querySelectorAll('.products');

	if (!products) return;

	products.forEach(item => {
		const productPopup = item.querySelector('.product__popup'),
			popupContainer = item.querySelector('.popup__container'),
			popupContent = item.querySelector('.popup__content-wrap'),
			closeButton = productPopup.querySelector('.popup__close');

		function closePopup() {
			productPopup.classList.remove('show');
			document.body.classList.remove("overflow");
			enableScroll();
		}

		document.querySelector('body').addEventListener( 'click', e => {
			if ( e.target.classList.contains('product__button') || e.target.parentNode.classList.contains('product__button') ) {
				const productButton = e.target.classList.contains('product__button') ? e.target : e.target.parentNode;

				const popupID = productButton.getAttribute('data-id'),
					url = themeVars.ajaxurl,
					bodyData = {
						action: 'action=get_popup_data',
						nonce: '&nonce_code=' + themeVars.nonce,
						id: '&post_id=' + popupID,
					};

				fetch(url, {
					method: "post",
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
					body: bodyData.action + bodyData.nonce + bodyData.id,
				})
					.then((response) => response.text())
					.then((result) => {
						if (result) {
							popupContent.innerHTML = "";
							popupContent.innerHTML = result;
							document.body.classList.add("overflow");
							productPopup.classList.add('show');
						}
					})
					.catch((error) => {
						console.error(error);
					});
			}
		});

		closeButton.addEventListener('click', closePopup);

		productPopup.onclick = function(e){
			if ( e.target != popupContainer && productPopup.classList.contains('show') && e.target == productPopup ) {
				closePopup();
			}
		};

	});
}



// WEBPACK FOOTER //
// ./scripts/modules/product-popup.js